import OTPBlock from './OTPBlock'
import { useSelector } from '@/lib/store'

const LoginStep2 = ({ isMobile }: any) => {
  const loginState = useSelector((state) => state?.login)
  return (
    <div
      className={`w-full ${
        !isMobile ? 'pt-16 border-l border-solid border-gray-100' : ''
      }`}
    >
      <div className="border-b border-solid border-gray-100">
        <h2 className="text-body-lg sm:text-heading-md font-bold text-primary mb-2 text-center">
          Verify details
        </h2>
        <div className="flex-row flex justify-center">
          <p className="text-body-sm sm:text-body-md xl:text-label-lg font-semibold text-gray-700 mb-6 text-center">{`OTP sent to`}</p>
          <p className="text-body-sm sm:text-body-md xl:text-label-lg font-semibold text-gray-900 mb-6 ml-2 text-center">{`+91 ${loginState?.phoneNumber}`}</p>
        </div>
      </div>
      <div
        className={`py-6 border-b border-solid border-gray-100 ${
          !isMobile ? ' px-10' : ' px-4'
        }`}
      >
        <OTPBlock />
      </div>
    </div>
  )
}

export default LoginStep2
